import suppliersAPI from '@/app/apis/main/suppliers/suppliers-api.js';

export default {
    /**
     * @return {object} Suppliers List
     */
    async getSuppliersList() {
        return suppliersAPI.getSuppliersList();
    },

};